import { Component, OnInit } from '@angular/core';
import { PlantService } from '../../services/plant.service';

@Component({
  selector: 'app-plant-list',
  templateUrl: './plant-list.component.html',
  styleUrls: ['./plant-list.component.scss']
})
export class PlantListComponent implements OnInit {
  navSwiper;
  swiper;
  currentDatetime;
  plantList = [];
  headerList = ['Name', 'Data Logger', 'Postcode', 'State', 'Y.Yield', 'Yield', 'Capacity', 'Warranty', 'Condition'];
  constructor(
    private plantService: PlantService
  ) { }

  ngOnInit(): void {
    setInterval(() => { this.currentDatetime = Date.now() }, 1000);
    this.initData();
    setInterval(() => { this.initData() }, 1 * 60 * 60 * 1000); //  one hour load once
  }

  initData() {
    this.plantService.getPlantList().subscribe(resp => {
      // console.log(`plant list resp >> ${JSON.stringify(resp.data)}`)
      const plantList = resp.data.list;
      const section = Math.ceil(plantList.length / 10);
      const mockArray = [...Array(section).fill(0)];
      for (const i of mockArray) {
        let length = 10;
        if (plantList.length < 10) {
          length = plantList.length;
        }
        const partition = plantList.splice(0, length);
        this.plantList.push(partition);
      }
      // let split = plantList.splice(0, 10);
      // this.plantList = [split];
      // while (split && split.size >= 10) {
      //   split = plantList.splice(0, 10);
      //   this.plantList.push(split);
      // }
      console.log(`this.plantList >> ${this.plantList.length}`);
    });
  }

  onNavSwiperInit(swiper) {
    this.navSwiper = swiper;
  }

  onSwiper(swiper) {
    this.swiper = swiper;
  }
}
